(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smooth-scroll"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__poutSmoothScrollBound) return;
    window.__poutSmoothScrollBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-smooth-scroll]');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      var hash = href.slice(hashIndex);
      if (hash.length < 2) return;

      if (href.charAt(0) !== '#') {
        try {
          var url = new URL(href, window.location.href);
          if (url.pathname !== window.location.pathname) return;
        } catch (e) {
          return;
        }
      }

      var target;
      try {
        target = document.querySelector(hash);
      } catch (e) {
        return;
      }
      if (!target) return;

      event.preventDefault();
      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: reduced ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
